module.exports = __webpack_public_path__ + "61fc13046e3392557c943845ac156e49.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/raw-key-art-320.jpg
// module id = 520
// module chunks = 0